import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'

class NotificationComponent extends BaseComponent {
  closeBtn: Nullable<HTMLElement>
  alert: Nullable<HTMLElement>
  alertText: Nullable<HTMLElement>
  showTimeoutId: any

  constructor() {
    super()

    this.closeBtn = this.querySelector('[data-notification-close-button]')
    this.alert = this.querySelector('[data-notification-alert]')
    this.alertText = this.querySelector('[data-notification-alert-text]')
  }

  connectedCallback(): void {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.handleCloseButtonClick)
    }
  }

  disconnectedCallback(): void {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.handleCloseButtonClick)
    }
  }

  handleCloseButtonClick = (): void => {
    this.hide()
  }

  show(errorText: string, variant: string, duration: number = 3000): void {
    this.setAlert(errorText, variant || 'warning')

    if (this.showTimeoutId) {
      clearTimeout(this.showTimeoutId)
    }

    this.setVisible(true)

    this.showTimeoutId = setTimeout(() => {
      this.setVisible(false)
    }, duration)
  }

  hide(): void {
    this.setVisible(false)
  }

  setVisible(isVisible: boolean): void {
    this.toggleAttribute('open', isVisible)
  }

  setAlert(errorText: string, variant: string): void {
    if (this.alert && this.alertText) {
      this.alert.setAttribute('alert-type', variant)
      this.alertText.innerHTML = errorText
    }
  }
}

export default NotificationComponent
